// src/lib/ws.ts
function resolveFromEnv(): string | null {
  const v = process.env.REACT_APP_AUDIO_WS;
  if (v && typeof v === "string" && v.trim()) return v.trim();
  return null;
}

function resolveFromHost(): string | null {
  try {
    const host = window.location.host.toLowerCase();
    const proto = window.location.protocol;
    if (host === "demo.getcueboard.com" && proto === "https:") {
      return "wss://cueboard-stt-cloud.onrender.com/stream";
    }
  } catch {}
  return null;
}

export function getWsUrl(): string {
  const fromEnv = resolveFromEnv();
  const fromHost = resolveFromHost();
  const fallback = "ws://127.0.0.1:8787/stream";
  const url = fromEnv || fromHost || fallback;
  try { console.log("[WS] resolved url:", url, fromEnv ? "(env)" : fromHost ? "(host)" : "(fallback)"); } catch {}
  return url;
}
